import { applyMiddleware, createStore } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import rootReducer from './root-reducer';
import rootEpic from './root-epic';
import { createBrowserHistory } from 'history';
import { routerMiddleware as createRouterMiddleware } from 'connected-react-router';
import { composeWithDevTools } from 'redux-devtools-extension';
import logger from 'redux-logger';

export const history = createBrowserHistory();
const routerMiddleware = createRouterMiddleware(history);
const epicMiddleware = createEpicMiddleware();

const middleware =
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(epicMiddleware, routerMiddleware)
    : composeWithDevTools(applyMiddleware(epicMiddleware, routerMiddleware, logger));

const store = createStore(rootReducer(history), middleware);
export default store;
epicMiddleware.run(rootEpic);
